import { DatesModel } from "../model";
const WeekDays = [
    "day-0",
    "day-1",
    "day-2",
    "day-3",
    "day-4",
    "day-5",
    "day-6"
];
const Months = [
    "month-0",
    "month-1",
    "month-2",
    "month-3",
    "month-4",
    "month-5",
    "month-6",
    "month-7",
    "month-8",
    "month-9",
    "month-10",
    "month-11"
];
const OneDay = 1 * 24 * 60 * 60000;
export class GroupedSportsToDatesMapper {
    constructor(dict) {
        this.dict = dict;
    }
    getDates(response, timezone) {
        const timezoneShift = (this.today.getTimezoneOffset() + timezone * 60) * 60000;
        return response && response.sports
            ? this.mapToDates(response.sports, timezoneShift, this.today)
            : [];
    }
    setToday(date) {
        this.today = date;
    }
    mapToDates(sports, timezoneShift, today) {
        return sports.reduce(this.groupsReducer.bind(this), []).map((date, index) => this.getDatesModel(date, index, timezoneShift, today));
    }
    groupsReducer(accumulator, current) {
        let count = current.sport
            ? this.getFixturesCount(current.sport, current.date)
            : 0;
        if (current.date && count > 0) {
            accumulator.push({ date: new Date(current.date), fixturesCount: count });
        }
        return accumulator;
    }
    getDatesModel(dateWithCount, index, timezoneShift, today) {
        const shiftedDate = this.shiftDate(dateWithCount.date, timezoneShift);
        return new DatesModel({
            id: shiftedDate.getDate().toString(),
            from: dateWithCount.date,
            timeRange: "OneDay",
            order: index,
            dayOfWeek: this.getDayOfWeek(dateWithCount.date, today, shiftedDate.getDay()),
            formattedDate: this.getFormattedDate(shiftedDate),
            fixturesCount: dateWithCount.fixturesCount
        });
    }
    getDayOfWeek(date, today, dayNumber) {
        const diff = date.getTime() - today.getTime();
        if (!diff) {
            return this.dict.Today;
        }
        else if (diff === OneDay) {
            return this.dict.Tomorrow;
        }
        else {
            return this.dict[WeekDays[dayNumber]];
        }
    }
    getFormattedDate(date) {
        const day = date.getDate();
        const month = Months[date.getMonth()];
        return `${this.dict[month]} ${day}`;
    }
    shiftDate(day, timezoneShift) {
        return new Date(day.getTime() + timezoneShift);
    }
    getFixturesCount(currentSport, currentDateAsString) {
        let currentDate = this.getCurrentDate(currentDateAsString);
        let fixturesCount = this.getCount(currentSport.fixturesCount);
        let liveFixturesTotalCount = this.getCount(currentSport.liveFixturesTotalCount);
        return this.today.getTime() === currentDate.getTime() ? fixturesCount - liveFixturesTotalCount : fixturesCount;
    }
    getCount(count) {
        return count || 0;
    }
    getCurrentDate(currentDateAsString) {
        return currentDateAsString ? new Date(currentDateAsString) : this.today;
    }
}
//# sourceMappingURL=DatesMapper.js.map